import { Component } from '@angular/core';
import { BaryComponentHelper } from '../../../../util/bary-component-helper';
import { BaryModalEvent, IBaryModalEvent } from '../../../../../../models/bary-modal-event';
import { IMyDate, MDBModalRef } from 'ng-uikit-pro-standard';
import { API_ENDPOINTS } from '../../../../../../models/enums/endpoints.enum';
import { FormControl } from '@angular/forms';
import { TransportOrderExtendedService } from 'services/transport-order-extended.service';
import { mapAsBody } from '../../../../util/request-util';
import dayjs from 'dayjs';

@Component({
  selector: 'jhi-bary-modal-confirm-delivery',
  templateUrl: './bary-modal-confirm-delivery.component.html',
  styleUrls: ['./bary-modal-confirm-delivery.component.scss'],
})
export class BaryModalConfirmDeliveryComponent {
  action = BaryComponentHelper.generateAction<IBaryModalEvent>();
  transportOrderId!: number;
  podURL = API_ENDPOINTS.CONFIRM_DELIVERY;

  controls = {
    podControl: new FormControl(),
    picturePreview: new FormControl(),
    deliveryDate: new FormControl(new Date()),
  };
  dateOption: { minDate: IMyDate; maxDate: IMyDate; disableUntilDate: IMyDate };

  constructor(public modalRef: MDBModalRef, private transportOrderService: TransportOrderExtendedService) {
    // la min date est de un an avant.
    const minDate = dayjs().set('year', 2019).set('month', 0).set('day', 1);
    this.dateOption = {
      minDate: { year: minDate.year(), month: minDate.month() - 1, day: minDate.date() },
      maxDate: { year: dayjs().year() + 1, month: 12, day: 31 },
      disableUntilDate: { year: minDate.year(), month: minDate.month() - 1, day: minDate.date() },
    };
  }

  handleClick(from: any): void {
    if (from.submit) {
      this.transportOrderService.confirmDelivery(this.transportOrderId, this.controls.deliveryDate!.value!, this.controls.picturePreview.value).pipe(mapAsBody).subscribe();
    }

    this.action.next(new BaryModalEvent(from));
    this.modalRef.hide();
  }
}
